<template>
  <QForm ref="formRef">
    <QCardSection class="flex flex-col gap-16 p-24">
      <div class="flex flex-col gap-16">
        <span class="text-caps-3 text-neutral-70">
          {{ t('materialToBe') }}
        </span>
        <p
          v-if="subtextoAlternativa"
          class="text-paragraph-3 text-neutral-100 whitespace-pre-wrap"
        >
          {{ subtextoAlternativa }}
        </p>
      </div>
    </QCardSection>

    <q-separator />

    <QCardSection class="p-24">
      <FileUploader
        multiple
        accept=""
        container-class="h-96 p-12 flex flex-col items-center justify-center gap-6 rounded-md border border-dashed border-neutral-100/10 hover:border-neutral-100/30 bg-card-300 transition-all cursor-pointer"
        @change="(value) => (model.files = value)"
      >
        <p class="text-paragraph-4 text-neutral-70">
          {{ t('attachHereYour') }}
        </p>
        <div
          class="h-32 grid place-items-center bg-white border border-neutral-100/10 rounded-md px-10 mt-8"
        >
          <p class="text-headline-4 text-neutral-100">
            {{ t('selectFiles') }}
          </p>
        </div>
      </FileUploader>
    </QCardSection>

    <q-separator />

    <QCardSection class="flex flex-col gap-16 p-24">
      <h3 class="text-headline-3 text-neutral-100">
        {{ t('hereYouCan') }}
      </h3>

      <OSelect
        :model-value="model.alternativas"
        :label="t('selectTheMaturity')"
        :options="optionsNiveisMaturidade"
        size="md"
        multiple
        emit-value
        map-options
        option-label="titulo"
        option-value="id"
        class="w-full"
        :class="{
          readonly: disabledNiveisMaturidade,
        }"
        :disable="disabledNiveisMaturidade"
        :rules="[(value) => value.length > 0]"
        @update:model-value="(value) => (model.alternativas = value)"
      />
    </QCardSection>

    <q-separator />

    <QCardSection class="w-full mb-80">
      <OInput
        v-model="model.comentario"
        size="lg"
        type="textarea"
        :label="t('comment')"
        stack-label
        :placeholder="t('writeHere')"
        class="showPlaceholderOnStack"
      />
    </QCardSection>
  </QForm>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useEvidencia } from 'composables/useEvidencia'
import { useI18n } from 'vue-i18n'
import FileUploader from 'components/FileUploader/FileUploader.vue'
import OInput from 'components/Input/OInput.vue'
import OSelect from 'components/Select/OSelect.vue'
import usePerguntas from 'composables/usePerguntas'

const { t } = useI18n()

const model = ref({
  files: [],
  alternativas: [],
  comentario: '',
  pergunta: null,
})

const { pergunta, alternativas, modalEvidenciaCreateRef } =
  usePerguntas()

watch(
  () => modalEvidenciaCreateRef.value.state.data.alternativa,
  (v) => {
    if (!v?.id) return
    model.value.alternativas = [v.id]
  },
  { immediate: true }
)

watch(
  () => modalEvidenciaCreateRef.value.state.data.sendAll,
  (v) => {
    if (!v) return
    model.value.alternativas = []
    model.value.pergunta = pergunta.value.id
  },
  { immediate: true }
)

const subtextoAlternativa = computed(() => {
  return (
    modalEvidenciaCreateRef.value?.state?.data?.alternativa
      ?.subtexto || ''
  )
})

const optionsNiveisMaturidade = computed(() =>
  alternativas.value.filter((alternativa) => {
    return !alternativa.tem_evidencia
  })
)

const disabledNiveisMaturidade = computed(() => {
  return modalEvidenciaCreateRef.value.state.data.sendAll
})

const formRef = ref(null)

defineExpose({
  model,
  formRef,
})
</script>

<style lang="scss" scoped></style>
